<div class="contact-us-page" [class.contact-us-page--guest]="!isLoggedIn" [class.login-page]="isLoggedIn">
  @if (isLoggedIn) {
    <app-topnav [llttfPage]="llttfPage"></app-topnav>
  }
  @if (!isLoggedIn) {
    <app-top-nav-login [bbApp]="true"></app-top-nav-login>
  }

  @if (!isLoggedIn) {
    <div class="contact-us-page__banner">
      <div class="container">
        <h1>{{ 'contactUsText' | translate:translations }}</h1>
      </div>
    </div>
  }

  <div class="container" [class.contact-us-page__body]="!isLoggedIn">
    <div class="content" role="main">
      <div class="cmha-dashboard">
        @if (isLoggedIn) {
          <div class="participant-banner" [ngClass]="bannerClass">
            <div class="container">
              <h2>{{ 'contactUsText' | translate:translations }}</h2>
            </div>
          </div>
        }
        @if (isLoggedIn) {
          <div class="h-30"></div>
        }

        <div class="container" [class.contact-us-page__guest-content]="!isLoggedIn">
          @if (subHeading) {
            <p class="contact-us-page__intro">{{ subHeading }}</p>
          }

          <form #rpform="ngForm" (ngSubmit)="onSubmit(rpform)" [class.contact-us-page__form]="!isLoggedIn">
            <div class="form-fields">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Your Email Address</mat-label>
                <input
                  matInput
                  type="email"
                  class="form-control-textbox"
                  [(ngModel)]="email"
                  #emailInput="ngModel"
                  name="email"
                  required
                  email
                  [disabled]="isLoggedIn" />
                  @if (emailInput.errors?.['required'] && (emailInput.touched || isSubmitted)) {
                    <mat-error>
                      Email address is required
                    </mat-error>
                  }
                  @if (emailInput.errors?.['email'] && (emailInput.touched || isSubmitted)) {
                    <mat-error>
                      Please enter a valid email address
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="mb-30"></div>

              <div class="form-fields">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>Your Message</mat-label>
                  <textarea
                    matInput
                    class="form-control-textbox contact-us-page__message"
                    cols="5"
                    rows="10"
                    [(ngModel)]="contactusModel.message"
                    #messageInput="ngModel"
                    name="message"
                  required></textarea>
                  @if (messageInput.errors?.['required'] && (messageInput.touched || isSubmitted)) {
                    <mat-error>
                      Message is required
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="form-buttons" [class.contact-us-page__actions]="!isLoggedIn">
                <input type="submit" class="submit-form-button" value="Submit" />
                <a [routerLink]="cancelPath" class="submit-form-button cancel-button">Cancel</a>
              </div>
            </form>
          </div>

          <div class="h-30"></div>
        </div>
      </div>
    </div>

    @if (isLoggedIn) {
      <app-footer></app-footer>
    }
    @if (!isLoggedIn) {
      <app-footer [bbapp]="true" [showLogos]="true" [showBrandImage]="false"></app-footer>
    }
  </div>
